import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  submitDeclarationPanel,
  submitEnclosureFiles,
} from "../../auth/services/privateapicalling";
import { ToastContainer,toast } from "react-toastify";
interface DeclareProps {
  existData: any;
  isDeclarationFilled: boolean;
  onPrev: () => void;
}

const Declaration: React.FC<DeclareProps> = ({
  existData,
  isDeclarationFilled,
  onPrev,
}) => {
  const token = useSelector((state: any) => state.auth.token);
  const language = useSelector((state: any) => state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage);

  const [showModal, setShowModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [captchaChecked, setCaptchaChecked] = useState(false);
  const [error, setError] = useState<string>("");
  const [declarationDetail, setDeclarationDetail] = useState<any>(existData);
  const [isChecked, setIsChecked] = useState(false);

  const navigate = useNavigate();

  // Handle PDF Upload
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setUploadedFile(file);
      setError("");
      //.log("Uploaded File:", file.name);
    }
  };

  const handleRecaptchaChange = () => {
    setCaptchaChecked(true);
    setError("");
  };

  const validateForm = () => {
    // if (!uploadedFile) {
    //   setError("Please upload the required document.");
    //   return false;
    // }
    // if (!captchaChecked) {
    //   setError("Please verify the reCAPTCHA checkbox.");
    //   return false;
    // }
    if (!isChecked) {
      setError("Please accept the declaration before proceeding.");
      return false;
    }
    return true;
  };

  // Navigate to Preview Screen
  const onPreview = () => {
    //.log("on ppppp");

    if (validateForm()) {
      //.log("Navigating to preview screen...");
      navigate(`/panel-application/${existData.applicationId}`);
    }
  };

  const handleDone = () => {
    setShowModal(false);
    navigate("/myApplicationPanel");
  };
  const [submitLoading,setSubmitLoading] = useState(false)

 
  const uploadDeclaration = async () => {
    setSubmitLoading(true)
    try {

        const decRes = await submitDeclarationPanel(existData?.applicationId, token);
  
        if (decRes.success == true) {
          setShowModal(true);
        } else toast.error(`${decRes.message}`);
        setSubmitLoading(false)
    } catch (error) {
      //.error("Error uploading declaration:", error);
      setError("Error uploading declaration. Please try again later.");
      setSubmitLoading(false)
    }
  };

  // Handle Form Submission
  const handleSubmit = async () => {
    if (validateForm()) {
      await uploadDeclaration();
    }
  };

  const handleDownload = (fileName: string) => {
    // fileNames.forEach((fileName) => {
      const fileUrl = `/${fileName}`; 
  
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    // });
  };

  useEffect(() => {
    //.log('existttdataaa', existData)
  }, []);

  return (
    <div className="card">
      <div className="card-header">
        <h6 className="card-title">{language.enter_details}-</h6>
      </div>
      <div className="card-body">
        <div className="row">
          {/* Applicant Declaration */}
          <div className="col-md-12 mb-3 ">
            <label className="form-label d-flex fs-3">
              {language.applicant_declaration}{" "}
              <span className="text-danger">*</span>
            </label>
            {/* <div className="">
              <a href="img/Panel_declaration.pdf" download className="d-flex">
                <p className="me-2">{language.down}</p>

                <i className="text-danger fa-file-pdf fas fs-30"></i>
              </a>
            </div> */}
            {/* <div className="d-flex align-items-center">
              <input
                type="file"
                className="form-control"
                accept=".pdf, .jpeg, .jpg"
                onChange={handleFileUpload}
              />
            </div> */}
          </div>

          {/* reCAPTCHA Section */}
          {/* <div className="d-flex justify-content-center text-center my-3">
            <ReCAPTCHA sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" onChange={handleRecaptchaChange} />
          </div> */}
        </div>

        {/* Error Message */}
        {error && <div className="text-center text-danger mb-3">{error}</div>}

        <div className="container mt-3">
          <div className="border p-3">
            <div className="form-check">
              <input
                type="checkbox"
                id="declaration"
                className="form-check-input"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
              />
              <label htmlFor="declaration" className="form-check-label fw-bold">
                I accept the declaration stated below:
              </label>
            </div>

            <div className="mt-2">
              <ol>
                <li>
                  1. નિયામકશ્રીના હુકમમાં સામેલ તમામ શરતો અમોને બંધનકર્તા છે તે અમે જાણીએ છીએ.
                </li>
                <li>
                  2. શરતોના ભંગ બદલ જે કોઈ કાર્યવાહી થશે તે અમોને માન્ય રહેશે.
                </li>
                <li>
                જો કોઇપણ અન્ય સરકારી સંસ્થા/એજન્સી દ્વારા અમોને/અમારી ફર્મ એજન્સીને બ્લેકલીસ્ટ કરવામાં આવે તો અમો નિયામક, ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર, ગુજરાત રાજ્ય, ગાંધીનગરની કચેરીને તુરંત જાણ કરીશું. ત્યારબાદ કોઇપણ બજાર સમિતિમાં પેનલ એન્જીનીયરને લગત કામગીરી અમો/પેઢી દ્વારા કરવામાં આવશે નહિં. જેની બાંહેધરી આપીએ છીએ.
                </li>
              </ol>
            </div>

            <div className="mt-2">
              <ol>
                <li>
                  1. We understand that all the conditions included in the
                  Director's order are binding on us.
                </li>
                <li>
                  2. Any action taken for breach of the terms and conditions will
                  be acceptable to us.
                </li>
                <li>
                  3. If we/our firm/agency are blacklisted by any other government
                  institution/agency, we will immediately inform the office of
                  the Director of Agriculture Marketing & Rural Finance,
                  Government of Gujarat, Gandhinagar. Thereafter, we/our firm
                  will not carry out any work related to the panel engineer in
                  any market committee. We hereby assure this.
                </li>
              </ol>
            </div>

            <div className="mt-4">
                <button
                  type="button"
                  className="btn btn-link text-danger"
                  onClick={() => {
                    handleDownload("DownloadCircular.pdf");
                  }}
                >
                  <span className="text-danger">Download Circular</span> <i
                    className="fa fa-file-pdf"
                    data-bs-toggle="tooltip"
                    title="Download Circular"
                  />
                </button>
            </div>
          
           
          </div>
        </div>

        {/* Action Buttons */}
        <div className="d-flex flex-column align-items-center mt-3">
          <button
            type="button"
            className="btn btn-primary mb-4"
            onClick={onPreview}
          >
            {language.preview_application}
          </button>
          <button
            type="button"
            disabled={submitLoading}
            className="btn btn-info btn-lg mb-4"
            onClick={handleSubmit}
          >
                 {submitLoading ? (
                      <i className="ion-load-a ion-spin"></i> // Loading spinner
                    ) : (
                      `${language.submit_application}`
                    )}
          </button>
          {/* <button type="button" className="btn btn-danger">{language.can}</button> */}
          <button
            type="button"
            className="btn btn-secondary mt-4"
            onClick={onPrev}
          >
            
            {language.previous}
          </button>
        </div>

        {/* Success Modal */}
        {showModal && (
          <div className="d-block modal fade show" tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="card bg-white border-0">
                  <div className="alert alert-secondary custom-alert1">
                    <button
                      type="button"
                      className="btn-close ms-auto"
                      data-bs-dismiss="alert"
                      aria-label="Close"
                    >
                      <i className="fa-xmark fas" />
                    </button>
                    <div className="text-center pb-0 px-5">
                      <div className="custom-alert-icon">
                        <i className="flex-shrink-0 feather-check-circle" />
                      </div>
                      <h5>{language.submitted_successfully}</h5>
                      <button className="btn btn-success" onClick={handleDone}>
                        {language.done}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer autoClose={3000} position="top-right"/>
    </div>
  );
};

export default Declaration;
